import { useTranslation } from 'react-i18next';

import styles from './LoyaltyChipBadge.module.css';

/**
 * Inline gift mark shown above the value on the cheapest option — flags it as
 * redeemable with loyalty points on the chip-based payment screens (SWRN-1739).
 * Colour is inherited via the `--loyalty-mark` custom property so a chip can
 * flip it to white in its selected state.
 */
export const LoyaltyChipBadge = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <span className={styles.mark} title={t<string>('loyalty.chipBadge.title')}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" />
                <path d="M3 8h18v4H3zM12 8v14M12 8a3 3 0 1 0-3-3c0 1.6 1.4 3 3 3zm0 0a3 3 0 1 1 3-3c0 1.6-1.4 3-3 3z" />
            </svg>
        </span>
    );
};
